import PropTypes from "prop-types";
import React from "react";
import { Button } from "reactstrap";
import "./SimpleButton.scss";

const B2CPreviousButton = ({IsonRecorder ,label, ...props }) => {
  return (
    <Button className={IsonRecorder
      ? "btn border bg-white disabled py-2 rounded-5 btn-lg"
      : "btn border bg-white py-2 rounded-5 btn-lg"} {...props}>
        <svg width="19" height="19" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
         <path d="M17.3914 9.46409H1.53546M1.53546 9.46409L9.46342 17.3921M1.53546 9.46409L9.46342 1.53613" stroke="#344054" stroke-width="2.26513" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

    </Button>
  );
};

B2CPreviousButton.propTypes = {
  label: PropTypes.string.isRequired,
};

export default B2CPreviousButton;
